import * as React from 'react';
import { Layout as AntLayout } from 'antd';
import { Outlet } from 'react-router-dom';
import { Banner } from './banner';
import { isMobile } from 'src/services/utils';
import { Footer } from './footer';

const { Content } = AntLayout;

export const LayoutAuth = () => {
    return <AntLayout style={{ height: '100vh' }}>
        {!isMobile && <Banner />}
        <Content className='site-layout' style={{ padding: '10px 25px', height: '100vh' }}>
            <Outlet />
        </Content>
        <Footer />
    </AntLayout>;
};
